import { isAvailable } from 'utils/rewards';

const FREE_PLAY_CATEGORY_PLS = 'freePlay';
const FREE_PLAY_CATEGORY_CMP = 'G - Electronic promo Credit to Machine';

export const getPlsFreePlayRewardValue = rewards => {
  const freePlayReward = rewards.find(
    r => r.category === FREE_PLAY_CATEGORY_PLS && isAvailable(r)
  );

  if (freePlayReward) {
    return freePlayReward.remainingValue.replace(/(\$\d+)(?:\.\d{2})?/, '$1');
  }

  return;
};

export const getCmpFreePlayRewardValue = rewards => {
  const freePlayReward = rewards.find(
    r => r.category === FREE_PLAY_CATEGORY_CMP && isAvailable(r)
  );

  if (freePlayReward) {
    return freePlayReward.description.match(/\$\d+/)?.[0] || '$5';
  }

  return;
};
